import React from 'react';
import Graphs from '../../utils/graphutil.js';
import Containers from '../../utils/containerutil.js';
import { Container } from '../components.js';


class RangeGrowth extends React.Component {

	constructor(props) {
		super(props);

		this.chartToggle = this.chartToggle.bind(this);

		this.getUserAgeData = this.getUserAgeData.bind(this);
		this.getUserGrowthData = this.getUserGrowthData.bind(this);

		this.state = {
			arougChart : 'growth',
			growth : {data : {}, dataError: false},
			agerange : {data : {}, dataError: false}
		};
	}

	componentDidMount() {
		if(this.state.agerange.data !== null && Object.keys(this.state.agerange.data).length === 0 && this.state.agerange.dataError === false) {
			this.getUserAgeData();
		}
		if(this.state.growth.data !== null && Object.keys(this.state.growth.data).length === 0 && this.state.growth.dataError === false) {
			this.getUserGrowthData();
		}
	}

	chartToggle(e) {
		if(this.state.arougChart !== e)
			this.setState({arougChart : e});
	}

	getUserAgeData() {
		var component = this;

		var callback = function(response) {
			if(response.detail !== "Report generated") {
				component.setState({agerange: {data: response.data, dataError : response.detail} });
			}
			else {
				component.setState({agerange: {data : response.data, dataError: false}});
			}
		};

		window._fiSponsor.getUserAgeData(callback);
	}

	getUserGrowthData() {
		var component = this;

		var callback = function(response) {
			
			if(response.detail !== "Report generated") {
				component.setState({growth : {data: response.data, dataError : response.detail}});
			}
			else {
				component.setState({growth : {data : response.data, dataError : false} });
			}
		};
		
		window._fiSponsor.getUserGrowthData(callback);
	}

	render() {
		var arChart;

		const arContainerSize = {
		    width : (this.props.size) ? this.props.size.width : '70vmin',
			height: (this.props.size) ? this.props.size.height : '61vmin'
		};

		//AROUG CHART STUFF ////////
		if(this.state.arougChart === 'range') {
			//If age range chart is selected
			arChart = Containers.getContainerDisplay(this.state.agerange, Graphs.users_by_age);
	  	}
	  	else if(this.state.arougChart === 'growth') {
	  		//If growth chart is selected
	  		arChart = Containers.getContainerDisplay(this.state.growth, Graphs.user_growth_chart);
	  	}
	  	///////////////////////////

	  	var note = (this.state.arougChart === 'range') ? 'See what age groups have been signing up and using Plinqit.' : 'Review your user growth.';

	  	var arougContainerLabels = [
	  		{'label' : 'User Growth', 'onClick': this.chartToggle, key: 'growth', selected: (this.state.arougChart === 'growth')},
	  		{'label' : 'Age Range of Users', 'onClick': this.chartToggle, key: 'range', selected : (this.state.arougChart === 'range')} 
	  	];

	  	return (
	  		<Container key='arou' 
	  		moreClass={'Container-Stackable Container-Grow ' + this.props.addClass} 
	  		titles={arougContainerLabels} titletype='toggle' note={note} 
	  		contents={arChart} size={arContainerSize} onclick={this.props.onclick} bgcolor="#48a7e3" />
	  	);

	}
}

export default RangeGrowth;